import { Button } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import logo from "@/assets/pabbit_icon_logo.png";

const IndexPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const groupId: string | null = queryParams.get("group_id");
  const roomId: string | null = queryParams.get("room_id");

  useEffect(() => {
    document.title = "Pabbit アプリインストール用";
    const userAgent = navigator.userAgent.toLowerCase();
    const isSafari: boolean = /safari/i.test(userAgent) && !/(chrome|crios|crmo|edg|edge)/i.test(userAgent);
    if (!isSafari && roomId) {
      window.location.href = import.meta.env.VITE_INVITATION_PABBIT_APP_URL_SCHEME + "?room_id=" + (roomId || "");
      return;
    }
    if (!isSafari && groupId) {
      window.location.href = import.meta.env.VITE_INVITATION_PABBIT_APP_URL_SCHEME + "?group_id=" + (groupId || "");
    }
  }, [groupId, roomId]);

  const handleDownload = (): void => {
    const isIOS: boolean = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS) {
      window.location.href = "https://apps.apple.com/jp/app/id6550900824";
    } else {
      window.location.href = "https://play.google.com/store/apps/details?id=cloud.pabbit2.app&hl=ja";
    }
  };

  return (
    <div>
      <div className="mb-8 mt-16 text-center text-xl font-normal">再配達いらず</div>
      <div className="mx-auto">
        <img alt="logo" className="mx-auto block h-full w-32" src={logo} />
      </div>
      <div className="mt-8 flex justify-center">
        <Button
          className="h-12 w-2/4 max-w-sm border border-[#00afcc] bg-white text-[#00afcc]"
          onClick={handleDownload}
        >
          今すぐダウンロード
        </Button>
      </div>
    </div>
  );
};

export default IndexPage;
